// extracted by mini-css-extract-plugin
export var chevronIcon = "_dp-2";
export var teamName = "_dp-1";
export var teamSwitcherButton = "_dp-0";